export type SnapshotState = 'Location' | 'Extension' | 'TakeSnapshot';

export const SNAPSHOT_ROUTE = {
  name: 'Snapshot',
  path: 'snapshot',
};
